module.exports = __webpack_public_path__ + "34d31fb71088f3e0cfb56855690ff3ec.jpg";